
function getBaseUrl() {
    if (window.baseAxios) {
        return window.baseAxios.baseUrl;
    } else {
        return '//live.alphalive.live';
    }
}
function getCmsBaseUrl() {
    if (window.baseAxios) {
        return window.baseAxios.cmsBaseUrl;
    } else {
        return '//live.alphalive.live/cms-glb';
    }
}
function getCmsApi() {
    if (window.baseAxios) {
        return window.baseAxios.cmsAPI;
    } else {
        return '//live.alphalive.live/cms-glb';
    }
}

const hosts = {
    getBase() {
        return {
            baseUrl: getBaseUrl(),
            cmsBaseUrl: getCmsBaseUrl(),
            cmsAPI: getCmsApi()
        };
    }
};

export default hosts;
